/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import {
  LOAD_PROJECT,
  SET_INITIAL_ASSETS_LOADED,
  SET_PLAYER_PLAYBACK_PROGRESS,
  SET_PLAYER_STATE,
  SET_SHOW_VIDEO_PREVIEW,
  SET_STREAMING,
} from "constants/ActionTypes";
import {
  LoadProjectAction,
  SetShowVideoPreviewAction,
  SetStreamingAction,
} from "types/Actions";
import { PlayerStateWithBuffering } from "types/Player";

export interface PlayerState {
  currentTime: number;
  duration: number;
  isPlaying: boolean; // deprecated in favor of playerState
  playerState: PlayerStateWithBuffering;
  initialAssetsLoaded: boolean;
  streaming: boolean;
  showVideoPreview: boolean;
}

export interface SetPlayerPlaybackProgressAction {
  type: typeof SET_PLAYER_PLAYBACK_PROGRESS;
  currentTime: number;
  duration: number;
}

interface SetInitialAssetsLoadedAction {
  type: typeof SET_INITIAL_ASSETS_LOADED;
}

export interface SetPlayerState {
  type: typeof SET_PLAYER_STATE;
  state: PlayerStateWithBuffering;
}

export type PlayerAction =
  | SetPlayerPlaybackProgressAction
  | SetInitialAssetsLoadedAction
  | LoadProjectAction
  | SetStreamingAction
  | SetShowVideoPreviewAction
  | SetPlayerState;

export default function PlayerReducer(
  state: Readonly<PlayerState>,
  action: PlayerAction
): PlayerState {
  switch (action.type) {
    case SET_PLAYER_PLAYBACK_PROGRESS:
      return {
        ...state,
        currentTime: action.currentTime,
        duration: action.duration,
      };
    case LOAD_PROJECT:
      return {
        ...state,
      };
    case SET_INITIAL_ASSETS_LOADED:
      return {
        ...state,
        initialAssetsLoaded: true,
      };
    case SET_PLAYER_STATE:
      return {
        ...state,
        playerState: action.state,
        isPlaying: action.state === PlayerStateWithBuffering.playing,
      };
    case SET_STREAMING:
      return {
        ...state,
        streaming: action.payload,
      };
    case SET_SHOW_VIDEO_PREVIEW:
      return {
        ...state,
        showVideoPreview: action.payload,
      };
    default:
      return state;
  }
}
